import { render, staticRenderFns } from "./xc-model.vue?vue&type=template&id=4e0a39cd&scoped=true"
import script from "./xc-model.vue?vue&type=script&lang=js"
export * from "./xc-model.vue?vue&type=script&lang=js"
import style0 from "./xc-model.vue?vue&type=style&index=0&id=4e0a39cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a39cd",
  null
  
)

export default component.exports